import moment from 'moment';
export default function translateRawProductGroup(raw) {
    const { client_settings } = raw.settings_json;
    return {
        abbrev: raw.abbrev,
        active: raw.active,
        createdTimestamp: moment.utc(raw.created_ts).unix(),
        hidden: raw.hidden,
        id: String(raw.id),
        modifiedTimestamp: moment.utc(raw.modified_ts).unix(),
        name: raw.name,
        productIds: raw.product_ids.map((i) => {
            return String(i);
        }),
        settings: {
            clientSettings: {
                displayItemsOrder: client_settings ? client_settings.display_items_order : undefined,
                displayItemsType: client_settings ? client_settings.display_items_type : undefined,
                thumbnail: client_settings ? client_settings.thumbnail : undefined,
            },
        },
    };
}
